import { Notification, NotificationPriority } from "types/Notification";
import Action, { ActionTypeData } from "reducers/Action";
import { parse, compareDesc, addSeconds } from "date-fns";
import toaster from "composants/toaster/toaster";

export interface NotificationState {
  notifications: Notification[];
}

const initialState: NotificationState = {
  notifications: []
};

type AllActions =
  | ActionTypeData<"FETCH_LIST_NOTIFICATION_SUCCESS", Notification[]>
  | ActionTypeData<"PUSH_NOTIFICATION", Notification>;

export const NOTIFICATION_PRIORITY_VALUE: Record<NotificationPriority, number> = {
  TEMPORARY: 0,
  LOW: 1,
  NORMAL: 2,
  HIGH: 3,
  CRITICAL: 4
};

export const NOTIFICATION_OVERLAY_LIMIT = 2;

function compareNotification(left: Notification, right: Notification): number {
  if (left.validatedAt == null && right.validatedAt != null) return -1;
  else if (left.validatedAt != null && right.validatedAt == null) return 1;

  const priorityLeftValue = NOTIFICATION_PRIORITY_VALUE[left.priority];
  const priorityRightValue = NOTIFICATION_PRIORITY_VALUE[right.priority];

  if (priorityLeftValue > priorityRightValue) {
    return -1;
  } else if (priorityRightValue < priorityLeftValue) {
    return 1;
  } else {
    const createdAtLeft = parse(left.createdAt);
    const createdAtRight = parse(right.createdAt);

    return compareDesc(createdAtLeft, createdAtRight);
  }
}

export default function notificationReducer(
  state: NotificationState = initialState,
  action: AllActions
): NotificationState {
  switch (action.type) {
    case "FETCH_LIST_NOTIFICATION_SUCCESS": {
      // const overlay = getOverlayTiming(action.payload);

      const notifications = [...action.payload];
      notifications.sort(compareNotification);

      return {
        notifications
      };
    }

    case "PUSH_NOTIFICATION": {
      console.log("push notif in reducer");
      const oldNotifications = state.notifications.filter(notif => action.payload.id !== notif.id);

      // si la valeur est différente, c'est que la notification existait déjà en interne
      // pas la peine d'afficher le toaster du coup.
      // on supprime de la old list afin d'update avec les nouvelles valeurs
      const existingNotification = oldNotifications.length !== state.notifications.length;

      console.log("notif exist", existingNotification);
      if (!existingNotification) {
        const value = NOTIFICATION_PRIORITY_VALUE[action.payload.priority];
        console.log(
          "notif value : ",
          value,
          action.payload.validatedBy,
          value >= NOTIFICATION_OVERLAY_LIMIT && action.payload.validatedBy == null
        );
        if (value >= NOTIFICATION_OVERLAY_LIMIT && action.payload.validatedBy == null) {
          toaster.notify(action.payload);
        }
      }

      const notifications = [action.payload, ...oldNotifications];
      // const overlay = getOverlayTiming([action.payload]);

      notifications.sort(compareNotification);

      return {
        notifications: notifications
        // overlay: {
        //   ...state.overlay,
        //   ...overlay
        // }
      };
    }

    default:
      return state;
  }
}
